import React, { useState, useEffect, useCallback } from "react";
import { Checkbox, Tabs, Spin } from "antd";
import Table from "@components/ResponsiveTable";
import { api } from "@redux/api";
import { useRole } from "@/hooks/use-role";

const { TabPane } = Tabs;

const FACILITY_USER_ROLES = [1, 2.1, 2.2, 3, 4];

const Settings = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const role = useRole();

  const isFacilityUser = FACILITY_USER_ROLES.includes(Number(role));

  const loadSubscriptions = useCallback(() => {
    setLoading(true);
    return api
      .getMySubscriptions()
      .then((response) => {
        const responseData = response?.data;
        const subscriptions = Array.isArray(responseData)
          ? responseData
          : Array.isArray(responseData?.results)
            ? responseData.results
            : [];
        setData(subscriptions);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    loadSubscriptions();
  }, [loadSubscriptions]);

  const updateSubscription = (record, field, checked) => {
    setLoading(true);
    api
      .changeMySubscription(record.id, { [field]: checked })
      .then(() => loadSubscriptions())
      .catch(() => {
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "Facility",
      dataIndex: "facility_name",
    },
    {
      title: "Subscribe to reports email",
      key: "subscribe_workorder_report",
      render: (text, record) => (
        <Checkbox
          checked={record.subscribe_workorder_report}
          onChange={(e) =>
            updateSubscription(record, "subscribe_workorder_report", e.target.checked)
          }
        />
      ),
    },
    {
      title: "Subscribe to service",
      key: "subscribe_service",
      render: (text, record) => (
        <Checkbox
          checked={record.subscribe_service}
          onChange={(e) =>
            updateSubscription(record, "subscribe_service", e.target.checked)
          }
        />
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Tabs defaultActiveKey="email-subscription">
        <TabPane tab="Email Subscription" key="email-subscription">
          <Spin spinning={loading}>
            <Table
              bordered
              dataSource={data}
              rowKey="id"
              pagination={false}
              columns={columns}
            />
          </Spin>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Settings;
